var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRoundedRightLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44667 3.74939C8.41494 3.66756 8.36736 3.5928 8.30667 3.52939L4.97333 0.196061C4.91117 0.133902 4.83738 0.084595 4.75617 0.0509548C4.67495 0.0173146 4.58791 0 4.5 0C4.32247 0 4.1522 0.0705253 4.02667 0.196061C3.96451 0.25822 3.9152 0.332014 3.88156 0.413228C3.84792 0.494443 3.83061 0.581488 3.83061 0.669394C3.83061 0.846929 3.90113 1.01719 4.02667 1.14273L6.22667 3.33606H1.16667C0.989856 3.33606 0.820287 3.4063 0.695262 3.53132C0.570238 3.65635 0.5 3.82592 0.5 4.00273C0.5 4.17954 0.570238 4.34911 0.695262 4.47413C0.820287 4.59916 0.989856 4.66939 1.16667 4.66939H6.22667L4.02667 6.86273C3.96418 6.9247 3.91459 6.99844 3.88074 7.07968C3.84689 7.16092 3.82947 7.24805 3.82947 7.33606C3.82947 7.42407 3.84689 7.51121 3.88074 7.59244C3.91459 7.67368 3.96418 7.74742 4.02667 7.80939C4.08864 7.87188 4.16238 7.92148 4.24362 7.95532C4.32486 7.98917 4.41199 8.00659 4.5 8.00659C4.58801 8.00659 4.67515 7.98917 4.75638 7.95532C4.83762 7.92148 4.91136 7.87188 4.97333 7.80939L8.30667 4.47606C8.36736 4.41266 8.41494 4.3379 8.44667 4.25606C8.51335 4.09375 8.51335 3.9117 8.44667 3.74939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedRightLight);
export default __webpack_public_path__ + "static/media/arrow-rounded-right-light.c0acbd40b34f99ef3000356bff5bb542.svg";
export { ForwardRef as ReactComponent };